import React, { Component } from 'react';
import { ProductBrandTemplate, ProductCategory, ProductOptionCategory } from '../infrastructure/AppConstants';
import { OrderTemplateSelect } from '../common/OrderTemplateSelect';
import { ProductCategorySelect } from '../common/ProductCategorySelect';
import { BaseOptionsView } from './BaseOptionsView';
import { CustomizedMachineModelView } from './CustomizedMachineModelView';
import { WidexSeriesView } from './WidexSeriesView';
import { OptionCategorySelect } from './OptionCategorySelect';
import { EardrumTypeView } from './EardrumTypeView';
import { EardrumMaterialColorView } from './EardrumMaterialColorView';
import { FormattedMessage } from "react-intl";

export class Options extends Component {
  static displayName = Options.name;

  constructor(props) {
      super(props);
       
      this.state = { selectedOrderTemplate: ProductBrandTemplate.WSA, selectedProductCategory: ProductCategory.CustomMade, selectedOptionCategroy: -1 };
      
      this.handleOrderTemplateChanged = this.handleOrderTemplateChanged.bind(this);     
      this.handleProductCategroyChanged = this.handleProductCategroyChanged.bind(this);
      this.handleOptionCategroyChanged = this.handleOptionCategroyChanged.bind(this);   
      this.getSelectedOptionCategroy = this.getSelectedOptionCategroy.bind(this);
    }

    handleOptionCategroyChanged(e) {
        this.setState({ selectedOptionCategroy: e });
    }

    getSelectedOptionCategroy() {
        return this.state.selectedOptionCategroy;
    }

    handleProductCategroyChanged(e) {
        this.setState({ selectedProductCategory: e, selectedOptionCategroy:-1 });
    }

    handleOrderTemplateChanged(e) {
        this.setState({ selectedOrderTemplate: e, selectedOptionCategroy: -1  });
    }

    renderBaseOptionsView(selectedOptionCategroy) {
        return (<BaseOptionsView optionCategory={selectedOptionCategroy}/>);
    }

    renderCustomizedMachineModelView(getSelectedOptionCategroy) {
        return (<CustomizedMachineModelView getSelectedOptionCategroy={getSelectedOptionCategroy} />);
    }

    renderWidexSeriesView() {
        return (<WidexSeriesView />);
    }

    renderEardrumTypeView(selectedOptionCategroy) {
        return (<EardrumTypeView optionCategory={selectedOptionCategroy}/>);
    }

    renderEardrumMaterialColorView() {
        return (<EardrumMaterialColorView />);
    }



    render() {
        var content = '';
        let { selectedOrderTemplate, selectedProductCategory, selectedOptionCategroy } = this.state;
        if (selectedOptionCategroy === -1) {
            //Do nothing
        }
        else {
            if (selectedOrderTemplate == ProductBrandTemplate.Widex) {
                if (selectedProductCategory == ProductCategory.Eardrum) {
                    content = this.renderBaseOptionsView(selectedOptionCategroy);
                }
                else {
                    switch (selectedOptionCategroy) {
                        case ProductOptionCategory.WidexSeries:
                            content = this.renderWidexSeriesView();
                            break;
                        case ProductOptionCategory.MadeStyle:
                        case ProductOptionCategory.OtherMade:
                        case ProductOptionCategory.Spiracle:
                        case ProductOptionCategory.SpiracleSize:
                            content = this.renderBaseOptionsView(selectedOptionCategroy);
                            break;
                        default:
                            content = this.renderWidexSeriesView();
                            break;
                    }
                }
            }
            else {
                if (selectedProductCategory == ProductCategory.Eardrum) {
                    switch (selectedOptionCategroy) {
                        case ProductOptionCategory.EardrumBte:
                        case ProductOptionCategory.EardrumRic:
                            content = this.renderEardrumTypeView(selectedOptionCategroy);
                            break;
                        case ProductOptionCategory.EardrumMaterialColor:
                            content = this.renderEardrumMaterialColorView();
                            break;
                        case ProductOptionCategory.EardrumBteVent:
                        case ProductOptionCategory.EarmoldBteTubeDiameter:
                        case ProductOptionCategory.EarmoldBteTubeLength:
                        case ProductOptionCategory.EarmoldBteLength:
                        case ProductOptionCategory.EardrumRicVent:
                        case ProductOptionCategory.EarmoldRicReceiverVersion:
                        case ProductOptionCategory.EardrumRicCordLength:
                        case ProductOptionCategory.EardrumRicReceiver:
                        case ProductOptionCategory.EardrumRicCord:
                        case ProductOptionCategory.EardrumCategory:
                        case ProductOptionCategory.EardrumVersion:
                            content = this.renderBaseOptionsView(selectedOptionCategroy);
                            break;
                    }
                }
                else {
                    switch (selectedOptionCategroy) {
                        case ProductOptionCategory.CustomizedMachineModel:
                            content = this.renderCustomizedMachineModelView(this.getSelectedOptionCategroy);
                            break;
                        case ProductOptionCategory.Attachment:
                        case ProductOptionCategory.AntiEarwaxDevice:
                        case ProductOptionCategory.Vent:
                        case ProductOptionCategory.OnlyForRICSeries:
                        case ProductOptionCategory.OtherOptions:
                        case ProductOptionCategory.Cord:
                        case ProductOptionCategory.ShellCoating:
                        case ProductOptionCategory.EnclosureColor:
                            content = this.renderBaseOptionsView(selectedOptionCategroy);
                            break;
                        case ProductOptionCategory.EnclosureImage:
                            content = this.renderEardrumTypeView(ProductOptionCategory.CustomizedMachineModel);
                            break;
                    }
                }
            }

        }
        
    return (
      <div className="mt-4 mx-4">
        <div className="w-full overflow-hidden rounded-lg shadow-xs bg-white">
                <div className="flex justify-start px-4 py-4">
                <label className="flex-none place-self-center mx-2"><FormattedMessage id="Company" /></label>
                <OrderTemplateSelect onValueSeleted={this.handleOrderTemplateChanged} />
                <label className="flex-none place-self-center mx-2"><FormattedMessage id="ProductCategory" /></label>                
                <ProductCategorySelect onValueSeleted={this.handleProductCategroyChanged} />                    
                    <label className="flex-none place-self-center mx-2"><FormattedMessage id="ProductOptionCategory" /></label>
                <OptionCategorySelect orderTemplate={this.state.selectedOrderTemplate}  productCategory={this.state.selectedProductCategory} onValueSeleted={this.handleOptionCategroyChanged} />                    
            </div>
        </div>
            <div className="w-full overflow-hidden rounded-lg shadow-xs bg-white mt-2">
          {content}          
        </div>       
      </div>
    );
  }
}
